export default __webpack_public_path__ + "static/media/Wolf's Armguards of the Grasslands.1ca0427d.jpg";